export const SERVICE_BASE = process.env.REACT_APP_BaseUrl;

export const AUTH_CONFIG = {
    clientId: process.env.REACT_APP_Msal_ClientId ?? '',
    tenantId: process.env.REACT_APP_Msal_TenantId,
    scope: process.env.REACT_APP_Msal_Scope    
  }

  
